export default __webpack_public_path__ + "static/media/check.f1983680.svg";